import { Component, Input, OnInit } from '@angular/core';
import { MockResourcesService } from '../../services/mock-resources.service';

@Component({
  selector: 'app-game-asset-preview',
  templateUrl: './game-asset-preview.component.html',
  styleUrls: ['./game-asset-preview.component.scss']
})
export class GameAssetPreviewComponent implements OnInit {
  @Input() data: any;
  @Input() color1: string;
  @Input() color2: string;
  @Input() s3BucketUrl: string;
  @Input() showTieBreaker: boolean = false;
  @Input() tieBreakerData: any[] = [];
  @Input() showButton: boolean = true;
  @Input() menuArt: string;

  profileImages: string[] = [];
  cashPrizeImage: string;
  locationIcon: string;

  constructor(public mockResourcesService: MockResourcesService) { }

  async ngOnInit() {
    const images = await this.mockResourcesService.getPlayerHowToPlayImages();

    this.profileImages = images && images.length
      ? images.map(img => `${this.s3BucketUrl}${img.value}`)
      : [];

    const cashPrizeImage = await this.mockResourcesService.getResourceCashPrize();
    if (cashPrizeImage) {
      this.cashPrizeImage = this.s3BucketUrl + cashPrizeImage.value;
    }

    const locationIcon = await this.mockResourcesService.getLocationIcon();
    if (locationIcon) {
      this.locationIcon = this.s3BucketUrl + locationIcon.value;
    }
  }
}
